import { useMemo } from "react";

import { formatPrice } from "@luce/core";
import { Box, Icon, Typography } from "@luce/ui";

import { groupInvoiceLineItems } from "../../lib";
import type { InvoiceDetailData } from "../../types";
import { InvoiceSection } from "./invoice-section";

export function InvoiceLineItems({ lineItems }: Pick<InvoiceDetailData, "lineItems">) {
  const groups = useMemo(() => groupInvoiceLineItems(lineItems), [lineItems]);

  return (
    <InvoiceSection icon="Notepad" title="Items">
      <Box className="gap-spacing-sm flex flex-col">
        {groups.map((group) => (
          <Box key={group.title} className="gap-spacing-xs flex flex-col">
            <Box className="gap-spacing-sm flex flex-row items-center">
              <Icon name="Sparkle" size={12} weight="fill" className="text-luce-brand-primary" />
              <Typography variant="body-sm" color="neutral-foreground-default" className="flex-1">
                {group.title}
              </Typography>
            </Box>
            {group.items.map((item) => (
              <Box
                key={item.key}
                className="gap-spacing-xs pl-spacing-md border-luce-neutral-border-highEmphasis ml-1.5 flex flex-row items-start border-l"
              >
                <Typography
                  variant="body-sm"
                  color="neutral-foreground-intermediate"
                  className="flex-1"
                >
                  {item.label}
                </Typography>
                <Typography variant="body-sm" color="neutral-foreground-default">
                  {formatPrice(item.amount)}
                </Typography>
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    </InvoiceSection>
  );
}
